'use client';

import { Montserrat } from 'next/font/google';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { Button } from '@/components/ui/button';
import { logger } from '@/lib/clientSideLogger';
import './globals.css';
const montserrat = Montserrat({
  subsets: ['latin'],
  variable: '--font-montserrat',
});

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  logger('error', error);
  const router = useRouter();
  return (
    <html>
      <body className={montserrat.variable}>
        <div className='flex min-h-screen flex-col items-center justify-center p-4'>
          <div className='space-y-4 text-center'>
            <h1 className='text-xl font-bold'>Something went wrong!</h1>
            <p className='text-muted-foreground'>
              A critical error occurred. Please try again.
            </p>
            <p className='text-muted-foreground text-sm'>
              If the problem persists, please contact{' '}
              <Link
                href='mailto:info@findhaven.org'
                className='block underline'
              >
                info@findhaven.org
              </Link>
            </p>

            <div className='flex justify-center gap-4 [&>*]:max-w-[200px]'>
              <Button onClick={reset} className='mt-4'>
                Try again
              </Button>
              <Button
                variant='outline'
                className='mt-4 flex-1'
                onClick={() => router.push('/')}
              >
                Go to home
              </Button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
